import FileSaver from 'file-saver';

export default class IngredientRiskService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(systemIngredientId) {
    return this.$http.get(`/api/report/ingredient_risk/${systemIngredientId}`, { responseType: 'blob' })
      .then((r) => {
        if (r && r.headers('File-Name')) {
          FileSaver.saveAs(r.data, r.headers('File-Name'));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/ingredient-risk/ingredient-risk.service.js